"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("utils/utils");
exports.default = (theme) => ({
    floorStyle: {
        minWidth: theme.defaults.content.pageMinWidth,
    },
    avatar: {
        borderRadius: 4,
        fontWeight: 500,
        '&.income': {
            backgroundColor: '#177212',
        },
        '&.bill': {
            backgroundColor: '#1f6bb1',
        },
    },
    root: {
        display: 'flex',
        flexWrap: 'no-wrap',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingBottom: 20,
        paddingLeft: theme.defaults.content.paddingLeftMobile,
        paddingRight: theme.defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: theme.defaults.content.paddingLeft,
            paddingRight: theme.defaults.content.paddingRight,
        },
        '@media (max-width: 769px)': {
            justifyContent: 'left',
        },
    },
    rootPaper: {
        width: '100%',
        boxShadow: 'none',
        zIndex: 1,
    },
    rootTable: {
        marginTop: 15,
    },
    selectedArrow: {
        '&:after': {
            content: '""',
            position: 'absolute',
            left: '100%',
            top: 32,
            border: '10px solid transparent',
            borderLeft: `10px solid ${theme.palette.greyScaleDeprecated[6]}`,
        },
    },
    fabStyle: {
        position: 'fixed',
        bottom: theme.spacing(8),
        right: theme.spacing(8),
        zIndex: 1,
    },
    fabStyle2: {
        position: 'fixed',
        bottom: theme.spacing(8),
        right: theme.spacing(18),
        zIndex: 1,
    },
    appBarWrapper: {
        borderBottom: `1px solid ${theme.palette.greyScaleDeprecated[4]}`,
        position: (0, utils_1.isBrowser)('safari') ? '-webkit-sticky' : 'sticky',
        top: theme.defaults.headers.headerHeight + 1,
        width: '100%',
        zIndex: 2,
        paddingLeft: theme.defaults.content.paddingLeftMobile,
        paddingRight: theme.defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: theme.defaults.content.paddingLeft,
            paddingRight: theme.defaults.content.paddingRight,
        },
    },
    tableBod: {
        width: '100%',
        minWidth: 300,
    },
    tableCellAvatar: {
        paddingLeft: 24,
        paddingRight: '24px !important',
        width: 45,
        '@media (min-width: 769px)': {
            display: 'table-cell',
        },
    },
    tableCellPayee: {
        paddingLeft: 10,
        '@media (min-width: 769px)': {
            paddingLeft: 0,
        },
    },
    tableCellAccount: {
        '@media (min-width: 769px)': {
            display: 'table-cell',
        },
    },
    tableCellCategory: {
        '@media (min-width: 769px)': {
            display: 'table-cell',
        },
    },
    tableCellAmount: {
        textAlign: 'right',
        paddingRight: '32px !important',
    },
    standardRow: {
        cursor: 'pointer',
        width: '100%',
        height: 78,
        '&:hover': {
            backgroundColor: 'rgba(220, 220, 220, 0.2) !important',
        },
        '& > td': {
            // paddingRight: 10,
            '@media (min-width: 769px)': {
                paddingRight: 15,
            },
        },
    },
    rowSticky: {
        position: 'sticky',
        top: theme.defaults.headers.headerHeight + 50,
        bottom: 0,
    },
    displayTable: {
        display: 'table',
    },
    schTxnForm: {
        position: 'sticky',
        top: theme.defaults.headers.headerHeight + 50,
        marginTop: 15,
        minWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.greyScaleDeprecated[7],
        '@media (max-width: 769px)': {
            minWidth: 340,
        },
        width: '100%',
    },
    shadedRow: {
        backgroundColor: `${theme.palette.greyScaleDeprecated[6]} !important`,
        zIndex: 2,
        '&:hover': {
            backgroundColor: `${theme.palette.greyScaleDeprecated[6]} !important`,
        },
    },
    ellipsedText: {
        display: 'block',
        maxWidth: 300,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    ellipseTextWrap: {
        maxWidth: 100,
    },
    shadowBar: {
        position: 'absolute',
        width: '23px',
        height: 'calc(100% + 17px)',
        backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.13) 0%, rgba(0,0,0,0.02) 40%, rgba(255, 255, 255,0) 100%)',
        transform: 'translate(0, -16px)',
        zIndex: 1,
    },
    greyHeight: {
        color: theme.palette.greyScaleDeprecated[2],
        paddingBottom: 15,
    },
    amtText: {
        fontSize: '16px',
        letterSpacing: '0.00938em',
        lineHeight: 1.5,
    },
    tabBar: {
        justifyContent: 'flex-start',
    },
    tabBarArrowButtons: {
        height: 40,
        top: 3,
        width: 40,
    },
    arrowLeft: {
        position: 'absolute',
        left: 0,
    },
    arrowRight: {
        position: 'relative',
        right: 0,
    },
    tab: {
        fontSize: '14px',
        letterSpacing: '1.25px',
        minWidth: 10,
        '& span span': {
            padding: 5,
        },
        '@media (min-width: 769px)': {
            '& span span': {
                padding: '5px 10px',
            },
        },
        '@media (min-width: 1281px)': {
            minWidth: 155,
            '& span span': {
                padding: 'inherit',
            },
        },
    },
    addbutton: {
        '&& span': {
            margin: 0,
        },
        '@media (min-width: 1281px)': {
            '&& span': {
                margin: '0 9px',
            },
        },
    },
    iconSpacing: {
        marginRight: theme.spacing(1),
    },
    verticalDivider: {
        width: 1,
        height: 24,
        borderRadius: 2,
        backgroundColor: theme.palette.greyScaleDeprecated[2],
    },
    appBarTitle: Object.assign(Object.assign({}, theme.components.appBar), { zIndex: 2 }),
    appBar: Object.assign(Object.assign({}, theme.components.appBar), { top: 70, zIndex: 2 }),
    toolBar: Object.assign({}, theme.components.toolBar),
    title: {
        lineHeight: 'inherit',
    },
    appBarGridContainer: {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto auto',
    },
    rightContent: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, auto)',
        alignItems: 'center',
        justifyContent: 'center',
        gridColumnGap: '10px',
    },
    sortToggleRoot: {
        display: 'flex',
        alignItems: 'center',
    },
    sortLabel: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.palette.text.secondary }),
    payeeCellRoot: {
        position: 'relative',
    },
    payeeCellRootPadding: {
        paddingRight: 70,
    },
    label: Object.assign(Object.assign({}, theme.typography.caption), { borderRadius: 6, position: 'absolute', right: 0, top: 0, padding: '2px 8px' }),
    overdueLabel: Object.assign(Object.assign({}, theme.typography.caption), { borderRadius: 6, position: 'absolute', right: 0, top: 0, padding: '2px 8px', background: theme.palette.color7.opacity50, color: theme.palette.red3 }),
    dueLabel: Object.assign(Object.assign({}, theme.typography.caption), { borderRadius: 6, position: 'absolute', right: 0, top: 0, padding: '2px 8px', background: theme.palette.color7.opacity50, color: theme.palette.other.dueTxn }),
    // mostly Dialog styles beyond here
    dialogRoot: {
        overflow: 'scroll',
    },
    tittle: {
        paddingBottom: 8,
    },
    titleSpacing: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    closeButton: {
        marginTop: -14,
        marginRight: -12,
        marginBottom: 2,
        padding: 10,
        float: 'right',
    },
    searchBar: {
        paddingLeft: 4,
        float: 'right',
        borderRadius: 4,
        backgroundColor: theme.palette.greyScaleDeprecated[5],
        '&.open': {
            width: 196,
        },
    },
    searchIcon: {
        height: 18,
        color: theme.palette.greyScaleDeprecated[2],
    },
    searchInput: {
        fontSize: '14px',
        lineHeight: 1.43,
        fontWeight: 'normal',
        color: theme.palette.greyScaleDeprecated[0],
    },
    greyGrid: {
        padding: '0px 14px',
        backgroundColor: theme.palette.greyScaleDeprecated[6],
    },
    buttonBottoms: {
        display: 'flex',
        flex: '0 0 auto',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 68,
        paddingBottom: 14,
        paddingLeft: 24,
        paddingRight: 24,
    },
    fatButton: {
        width: '173px',
        height: '36px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.greyScaleDeprecated[7],
        borderRadius: '20px',
        marginRight: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    manualLine: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        color: theme.palette.greyScaleDeprecated[2],
    },
    manualButton: {
        color: theme.palette.secondary.main,
        marginLeft: 6,
    },
    disabledSave: {
        color: `${theme.palette.greyScaleDeprecated[7]} !important`,
        opacity: 0.5,
    },
    primer: {
        paddingTop: 4,
    },
    cap: {
        paddingTop: 6,
    },
    disabledView: {
        display: 'block',
        width: '50%',
        marginTop: 40,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    margin40: {
        margin: 40,
    },
});
